// File: src/components/WebsiteTour/PracticeQuestionFeaturesTour.jsx

import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const PracticeQuestionFeaturesTour = ({ autoStart = true, onComplete }) => {
  const { startTour } = useShepherdTour(
    'practice_question_features', 
    TOUR_DATA.practice_question_features.steps, 
    autoStart, 
    onComplete
  );

  return null;
};

export default PracticeQuestionFeaturesTour;
